<template>
  <div id="projetsetup">
    <div class="left">
      <ul>
        <li v-for="(item, index) in leftlist" :key="index" :class="[item.name === title ? 'active' : '']" >
          <img :src="item.icon" />
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div class="line"></div>
    <div class="right">
      <div v-if="title != '角色权限管理'" :class="[{rightTop:title != '角色权限管理'}]">
        <span class="title">{{ title }}</span>
        <span class="tipe" v-if="title == '关键目录维护'&&fabutipsshow">当前版本尚未发布!</span>
      </div>
      <div :class="[{rightContent:title != '角色权限管理'}]" style="height:100%">
        <div v-if="title == '关键目录维护'" class="keyCatalog">
          <directoryMaintain></directoryMaintain>
        </div>
        <div v-if="title == '角色权限管理'" class="jueSeauthorization">
          <rolePermission ></rolePermission>
        </div>
        <div v-if="title == 'Revit版本设置'" class="RevitBanbenshezhi">
          <el-button v-if="releasePlann" :disabled="disabled1" type="primary" size="small" @click="releaseplan" >发布策划</el-button >
          <img v-if="releasePlann" :src="tanhao" class="tanhao" />
          <span v-if="releasePlann" class="titletipe" >提示：版本只能发布一次</span >
          <div class="content">
            <el-radio-group v-model="radio" :disabled="disabled1">
              <el-radio v-for="(item, index) in RevitVersionList" :label="item.revitId" :key="index" class="radioStyle" >{{ item.revitNameOrVersion }}</el-radio >
            </el-radio-group>
          </div>
        </div>
        <div v-if="title == '样板设置'" key="yangbanshezhi" class="yangbanshezhi">
          <div>
            <span>专业：</span>
            <el-select v-model="value" filterable placeholder="请选择" size="small" class="querySelect" clearable @change="queryagnben" >
              <el-option v-for="item in options" :key="item.id" :label="item.cnName" :value="item.id" @change="queryagnben" > </el-option>
            </el-select>
            <el-input v-model="input1" size="small" placeholder="请输入文件名称" prefix-icon="el-icon-search" class="queryInput" clearable @input="changeinput" > </el-input>
            <el-button v-if="addTemplate" type="primary" size="small" @click="addyangban" >添加样版</el-button >
            <el-button v-if="deleTemplate" type="danger" size="small" plain @click="delyangban" >删除</el-button >
          </div>
          <div class="tableBox">
            <el-table ref="multipleTable" :data="tableData" :row-style="rowStyle" :cell-style="cellStyle" :header-cell-style="headerStyle" tooltip-effect="dark" empty-text="" height="100%" @selection-change="selectChange1" >
              <template slot="empty">
                <img :src="zanwu" />
                <p style="font-size:16px;color:#000;">暂无数据</p>
              </template>
              <el-table-column type="selection" align="center">
              </el-table-column>
              <el-table-column label="序号" type="index" width="50">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" label="文件名称" prop="fileName" >
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" label="文件大小" prop="fileSize" >
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" label="Revit版本" prop="revitVersion" >
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="depName" align="center" label="所属公司" >
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="updateDate" align="center" label="修改时间" >
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="userName" align="center" label="上传人" >
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="remark" align="center" label="备注" >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="title == '标准图框设置'" key="banbenshezhi" class="banbenshezhi">
          <div class="queryNav">
            <el-button v-if="addFrame" type="primary" size="small" @click="addtukuang" >添加标准图框</el-button >
            <el-button v-if="deleFrame" type="danger" size="small" plain @click="deltukuang" >删除</el-button >
            <el-button v-if="downFrame" :disabled="tukuanggoudel.length != 1" type="primary" size="small" plain @click="dowtukuang" >下载</el-button >
          </div>
          <div class="tableBox">
            <el-table ref="multipleTable" :data="tableData2" :row-style="rowStyle" :cell-style="cellStyle" :header-cell-style="headerStyle" tooltip-effect="dark" empty-text="" height="100%" @selection-change="selectChange2" >
              <template slot="empty">
                <img :src="zanwu" />
                <p style="font-size:16px;color:#000;">暂无数据</p>
              </template>
              <el-table-column type="selection" align="center">
              </el-table-column>
              <el-table-column label="序号" type="index" width="50">
              </el-table-column>
              <el-table-column show-overflow-tooltip align="center" label="文件名称" prop="borderName" >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-dialogDrag :visible.sync="professionDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handlePofessionClose" title="添加样板" custom-class="profession-dialog" width="900px" >
      <span>
        <div class="search-header" style="margin-bottom:10px;">专业：
          <el-select v-model="value1" filterable placeholder="请选择" size="small" clearable style="vertical-align: bottom;" @change="addyangbantable" >
            <el-option v-for="item in options" :key="item.id" :label="item.cnName" :value="item.id" @change="addyangbantable" >
            </el-option>
          </el-select>
          <el-input v-model="specSearchInput" placeholder="请输入文件名称" style="width:200px;vertical-align: middle;" size="small" clearable @input="addyangbantable" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i >
          </el-input>
        </div>
        <el-table ref="multipleTable" :data="professionData" :cell-style="dialogCellStyle" :header-cell-style="dialogHeaderStyle" tooltip-effect="dark" style="width: 100%" height="210" @selection-change="handleSelectionSpecChange" >
          <template slot="empty">
            <img :src="zanwu" style="height:100px" />
            <p style="font-size:15px;color:#000;">暂无数据</p>
          </template>
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="序号" type="index" width="50">
          </el-table-column>
          <el-table-column prop="fileName" label="文件名称"> </el-table-column>
          <el-table-column prop="fileSize" label="文件大小(B)">
          </el-table-column>
          <el-table-column prop="revitVersion" label="Revit版本">
          </el-table-column>
          <el-table-column prop="depName" label="所属公司"> </el-table-column>
          <el-table-column prop="updateDate" label="修改时间">
          </el-table-column>
          <el-table-column prop="userName" label="上传人"> </el-table-column>
          <el-table-column prop="remark" label="备注" width="120">
          </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="professionDialogVisible = false">取 消</el-button>
        <el-button :disabled="!yangbengou.length" type="primary" @click="confirmAddSpec" >确 定</el-button >
      </span>
    </el-dialog>
    <el-dialog v-dialogDrag :visible.sync="professionDialogVisible1" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handlePofessionClose1" title="添加图框" custom-class="profession-dialog" width="900px" >
      <span>
        <div class="search-header" style="margin-bottom:10px;">
          <el-input v-model="specSearchInput1" placeholder="请输入关键字查询" style="width:200px" size="small" clearable @input="addtukaungtable" >
            <i slot="prefix" class="el-input__icon el-icon-search"></i >
          </el-input>
        </div>
        <el-table ref="multipleTable" :data="professionData1" :cell-style="dialogCellStyle" :header-cell-style="dialogHeaderStyle" tooltip-effect="dark" style="width: 100%" height="210" @selection-change="handleSelectionSpecChange1" >
          <template slot="empty">
            <img :src="zanwu" style="height:100px" />
            <p style="font-size:15px;color:#000;">暂无数据</p>
          </template>
          <el-table-column type="selection"> </el-table-column>
          <el-table-column label="序号" type="index"> </el-table-column>
          <el-table-column prop="fileName" label="文件名称"> </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="professionDialogVisible1 = false">取 消</el-button>
        <el-button :disabled="!tukuanggou.length" type="primary" @click="confirmAddSpec1" >确 定</el-button >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import requestprj from "@/CommonDP/service/standardPlan-service";
import { mapState } from "vuex";
import { checkPermission } from "@/utils/routeAuth";
import standardFrame from "@/CommonDP/service/standardDrawingFrame-service";
export default {
  components: {
    directoryMaintain: () => import("./components/directoryMaintain"),
    rolePermission: () => import('./components/rolePermission.vue')
  },
  data() {
    return {
      releasePlann: checkPermission(":setup:releasePlann"),
      addTemplate: checkPermission(":setup:addTemplate"),
      deleTemplate: checkPermission(":setup:deleTemplate"),
      addFrame: checkPermission(":setup:addFrame"),
      deleFrame: checkPermission(":setup:deleFrame"),
      downFrame: checkPermission(":setup:downFrame"),
      leftlist: [
        {
          name: "角色权限管理",
          icon: require('@/CommonDP/assets/settings/rolePermission.png')
        },
      ],
      title: "角色权限管理",
      radio: "",
      prjID: "",
      disabled1: false,
      RevitVersionList: [],
      tanhao:require('@/CommonDP/assets/settings/tanhao.png'),
      tableData: [],
      tableData2: [],
      professionData: [],
      professionDialogVisible: false,
      options: [],
      value: "",
      specSearchInput: "",
      input1: "",
      value1: "",
      professionDialogVisible1: false,
      specSearchInput1: "",
      professionData1: [],
      yangbengou: [],
      tukuanggou: [],
      tukuanggoudel: [],
      yangbengoudel: [],
      zanwu:require('@/CommonDP/assets/暂无数据.png'),
      fabutipsshow:false
      // 先判断有没有发布过 如果没有发布过 就一直存在 如果发布过 增删改查启用禁用上移下移都变false
    };
  },
  computed: {
    ...mapState({
      prjInfo: state => state.projectMg.prjObj,
      catalogInit: state => state.projectMg.catalogInit,
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo,
    }),
  },
  watch: {
    prjInfo: {
      deep: true,
      handler: function({ prjId }, oldValue) {
        if (prjId) {
          this.prjID = this.prjInfo.prjId;
          this.queryPrjRevitVersion();
        }
      }
    }
  },
  methods: {
    queryfabutips(type){
      // 发布过
      if(this.catalogInit==='1'){
        if(type==='1'){
          this.fabutipsshow=false
        }else{
          this.fabutipsshow=true
        }
      }else{
        this.fabutipsshow=true
      }
    },

    // 设置 Revit版本
    releaseplan() {
      if (this.radio) {
        requestprj.setPrjRevitVersion(this.prjID, this.radio).then(res => {
          if (res.result === "0") {
            this.$message({
              message: "设置成功",
              type: "success"
            });
            this.queryPrjRevitVersion();
          }
        });
      } else {
        this.$message({
          message: "请选择Revit版本",
          type: "warning"
        });
      }
    },
    // 判断Revit版本是否设置过
    queryPrjRevitVersion() {
      requestprj.getPrjRevitVersion(this.prjID).then(res => {
        if (res.result === "0") {
          if (res.data) {
            this.radio = res.data.revitId;
            this.disabled1 = true;
          } else {
            this.disabled1 = false;
          }
        }
      });
    },
    // 查询 所有Revit版本list数据
    getSysRevitVersionList() {
      requestprj.getSysRevitVersionList().then(res => {
        if (res.result === "0") {
          if (res.data) {
            this.RevitVersionList = res.data;
          }
        }
      });
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;height:54px;padding:0px;border-top:1px solid #EFF0F9";
    },
    rowStyle() {
      return "height:60px;";
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      return "height:60px";
    },
    // 勾选样本 删除
    selectChange1(val) {
      this.yangbengoudel = val;
    },
    // 标准图框 删除
    selectChange2(val) {
      this.tukuanggoudel = val;
    },
    dialogCellStyle() {
      return "padding:6px 0;";
    },
    dialogHeaderStyle() {
      return "background-color: #F7F9FF;color:#2E384D;height:35px;padding:4px 0;border-top:1px solid #EFF0F9";
    },
    // 弹筐里 勾选样板添加
    handleSelectionSpecChange(val) {
      this.yangbengou = val;
    },
    // 确定添加样本 按钮
    confirmAddSpec() {
      var arr = [];
      for (var i = 0; i < this.yangbengou.length; i++) {
        var data = {
          specId: this.yangbengou[i].specId,
          fileId: this.yangbengou[i].fileId,
          prjId: this.prjID,
          enterpriseId: this.enterpriseId
        };
        arr.push(data);
      }
      requestprj.revitTemplateSettingadd(arr).then(res => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.queryagnben();
          this.professionDialogVisible = false;
        }
      });
    },
    // 关闭样本弹框
    handlePofessionClose() {
      this.professionDialogVisible = false;
    },
    // open 添加样版
    addyangban() {
      this.professionDialogVisible = true;
      this.value1 = "";
      this.specSearchInput = "";
      this.yangbengou = [];
      this.addyangbantable();
    },
    // 样本表格数据
    queryagnben() {
      var data = {
        prjId: this.prjID,
        specId: this.value,
        fileName: this.input1
      };
      requestprj.getRevitTemplateList(data).then(res => {
        if (res.result === "0") {
          this.tableData = res.data;
        }
      });
    },
    // 样板里的专业
    queryagnbendoc() {
      requestprj.getSpecList(this.prjID).then(res => {
        if (res.result === "0") {
          this.options = res.data;
        }
      });
    },
    // 图框表格数据
    quertukuang() {
      var _this = this;
      requestprj.getStandardFiles(_this.prjID, this.enterpriseId).then(res => {
        if (res.result === "0") {
          _this.tableData2 = res.data;
        }
      });
    },
    // 添加样本的表格数据
    addyangbantable() {
      requestprj.getBySpecId( this.specSearchInput, this.value1, this.prjID, this.enterpriseId ).then(res => {
        if (res.result === "0") {
          this.professionData = res.data;
        }
      });
    },
    // 关闭图框 弹框
    handlePofessionClose1() {
      this.professionDialogVisible1 = false;
    },
    // 弹筐里  勾选图框 添加
    handleSelectionSpecChange1(val) {
      this.tukuanggou = val;
    },
    // 确定添加 图框
    confirmAddSpec1() {
      var arr = [];
      for (var i = 0; i < this.tukuanggou.length; i++) {
        arr.push(this.tukuanggou[i].fileId);
      }
      var data = {
        ids: arr,
        prjId: this.prjID
      };
      requestprj.batchAdd(data).then(res => {
        if (res.result === "0") {
          this.$message.success("添加成功");
          this.quertukuang();
          this.professionDialogVisible1 = false;
        }
      });
    },
    // open 图框
    addtukuang() {
      this.professionDialogVisible1 = true;
      this.tukuanggou = [];
      this.specSearchInput1 = "";
      this.addtukaungtable();
    },
    // 添加样本的表格数据
    addtukaungtable() {
      requestprj.getStandardFrameFiles( this.specSearchInput1, this.prjID, this.enterpriseId ).then(res => {
        if (res.result === "0") {
          this.professionData1 = res.data;
        }
      });
    },
    changeinput() {
      this.queryagnben();
    },
    // 样版删除
    delyangban() {
      if (this.yangbengoudel.length) {
        this.$confirm("此操作将删除选中的样本, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          var arr = [];
          for (var i = 0; i < this.yangbengoudel.length; i++) {
            var data = {
              prjId: this.prjID,
              fileId: this.yangbengoudel[i].fileId,
              specId: this.yangbengoudel[i].specId
            };
            arr.push(data);
          }
          requestprj.delete(arr).then(res => {
            if (res.result === "0") {
              this.$message.success("删除成功");
              this.queryagnben();
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      } else {
        this.$message.warning("请选择要删除的样版");
      }
    },
    // 图框删除
    deltukuang() {
      if (this.tukuanggoudel.length) {
        this.$confirm("此操作将删除选中的图框, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          var arr = [];
          for (var i = 0; i < this.tukuanggoudel.length; i++) {
            arr.push(this.tukuanggoudel[i].borderId);
          }
          var data = {
            prjId: this.prjID,
            ids: arr
          };
          requestprj.batchDelete(data).then(res => {
            if (res.result === "0") {
              this.$message.success("删除成功");
              this.quertukuang();
            }
          });
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
      } else {
        this.$message.warning("请选择要删除的图框");
      }
    },
    // 图框 下载
    dowtukuang() {
      const fileId = this.tukuanggoudel[0].borderId;
      const fileName = this.tukuanggoudel[0].borderName;
      standardFrame.downloadStandardFrameFile(fileId).then((response) => {
        if (response.type === 'application/json') {
          const fileReader = new FileReader()
          fileReader.onloadend = () => {
            const jsonData = JSON.parse(fileReader.result)
            // 后台信息
            this.$message({ message: jsonData.message, type: "error" });
          }
          fileReader.readAsText(response) // 或者读取response.data
        } else {
          const link = document.createElement("a");
          const blob = new Blob([response], {
            type: "application/octet-stream"
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
#projetsetup {
  width: 100%;
  height: 100%;
  .left {
    position: absolute;
    width: 235px;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    ul{
      margin-top:20px
    }
    li{
      text-align:left;
      cursor: pointer;
      height:38px;
      line-height:36px;
      margin-bottom:20px;
      img{
        vertical-align: middle;
        margin:0 3px 0 28px
      }
      span{
        vertical-align: middle;
      }
    }
    .active {
      background: #5584ff1a;
    }
  }
  .line {
    left: 235px;
    width: 13px;
    height: 100%;
    position: absolute;
    background: #eff1f6;
  }
  .right {
    left: 248px;
    height: 100%;
    background: #fff;
    width: calc(100% - 248px);
    position: absolute;
    border-radius: 4px;
    .title{
      margin-left:26px;
      font-size:16px;
      color: #333;
      font-weight:600
    }
    .tipe{
      color:#ee7171;
      font-size: 14px;
      margin-left: 12px;
    }
    .rightTop{
      border-bottom:1px solid #EBEFFF;
      height:60px;
      line-height:60px
    }
    .rightContent{
      padding:11px 23px 0 23px;
      height:calc(100% - 85px) !important
    }
    .banbenshezhi {
      height: 100%;
      .queryNav{
        margin-bottom:17px
      }
      .tableBox{
        height:calc(100% - 85px)
      }
    }
    .yangbanshezhi{
      height: 100%;
      .querySelect{
        width:207px;
        margin-right:12px;
        vertical-align: bottom;
      }
      .queryInput{
        width:192px;
        margin-right:10px;
        vertical-align: middle;
      }
      .tableBox{
        margin-top:22px;
        height:calc(100% - 85px)
      }
    }
    .RevitBanbenshezhi{
      height: 100%;
      .tanhao{
        width:16px;
        height:16px;
        vertical-align: middle;
        margin-left:28px;
      }
      .titletipe{
        color:#EF4545;
        font-size:14px;
        margin-left:5px;
      }
      .content{
        margin-top:41px
      }
      .radioStyle{
        margin-right:124px;
        font-size:14px
      }
    }
    .jueSeauthorization{
      height: 100%;
    }
    .keyCatalog{
      height: 100%;
    }
    .el-table__body-wrapper {
      height: 100%;
    }
    
  }
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
    }
    .el-button--primary {
      background: #4777e7;
      border-color: #4777e7;
    }
    .el-button--primary:hover {
      background: #7397ec;
      border-color: #7397ec;
    }
    .el-table__empty-text {
      line-height: 30px;
    }
  }
}
</style>
